import getLocationByZip from './get-location-by-zip';
import getLocationByIp from './getLocationByIp';
import getCompanyLogos from './get-company-logos';
import getProduct from './getProduct';
import getDevice from './getDevice';
import showPhoneNumber from './showPhoneNumber';
import getFPL from './getFPL';
import getInvocaPhoneV3 from './getInvocaPhoneV3';
import getPhoneCallManagement from './getPhoneCallManagement';

export default {
  getPhoneCallManagement,
  getInvocaPhoneV3,
  getLocationByZip,
  getLocationByIp,
  getCompanyLogos,
  getProduct,
  getDevice,
  showPhoneNumber,
  getFPL,
};
